import React, { useEffect, useState } from 'react';
import { material } from '../../../library/material';
import Snackbar from '../../toastrmessage/Snackbar';
import { StyledTableCell } from '../../../shared/TableHeaderStyle';
import 'react-loading-skeleton/dist/skeleton.css'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { deleteCosmeticTreatmentMaster, getAllCosmeticTreatmentMaster } from '../../../services/TreatmentListService';
import AddMasterTreatmentData from './AddMasterTreatmentData';

function ViewMasterTreatmentList(props) {

    const { setOpenViewMasterList, openViewMasterList, clinicDetails, userDetails } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });
    const [treatmentList, setTreatmentList] = useState([]);
    const [openAddTreatmentDialog, setOpenAddTreatmentDialog] = useState({ action: false, rowData: null });

    useEffect(() => {
        if (openViewMasterList) {
            getMasterTreatmentList()
        }
    }, [openViewMasterList]);

    const getMasterTreatmentList = () => {
        setIsLoading(true);
        const payload = {
            orgId: userDetails.orgId,
            clinicId: clinicDetails.clinicId
        }
        getAllCosmeticTreatmentMaster(payload)
            .then((resp) => {
                setTreatmentList(resp.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                const errorMessage =
                    error.response?.data?.data?.info ||
                    error.response?.data?.data ||
                    error.response?.data?.messages ||
                    "An unexpected error occurred";

                setOpenSnackBar({
                    action: true,
                    type: "error",
                    message: errorMessage,
                });
            })
    };

    const addTreatmentMaster = () => {
        setOpenAddTreatmentDialog({ action: true, rowData: null })
    };

    const handleClose = () => {
        setOpenViewMasterList(false)
    };

    const editTreatment = (rowData) => {
        setOpenAddTreatmentDialog({ action: true, rowData: rowData })
    };

    const deleteTreatment = (rowData) => {
        deleteCosmeticTreatmentMaster({ treatmentId: rowData.treatmentId })
            .then((resp) => {
                setOpenSnackBar({
                    "action": true,
                    "type": "success",
                    "message": resp.data.messages,
                })
                getMasterTreatmentList();
            })
            .catch((error) => {
                const errorMessage =
                    error.response?.data?.data?.info ||
                    error.response?.data?.data ||
                    error.response?.data?.messages ||
                    "An unexpected error occurred";

                setOpenSnackBar({
                    action: true,
                    type: "error",
                    message: errorMessage,
                });
            })
    };

    return (
        <div>
            <material.Dialog open={openViewMasterList} maxWidth="md" fullWidth hideBackdrop>
                <material.DialogTitle>View Skin Treatment Master List
                    <span className='float-end'>
                        <material.Button variant="contained" sx={{ textTransform: "none", mr: 1 }} startIcon={<material.AddIcon />} onClick={addTreatmentMaster}>Add Treatment Master</material.Button>
                        <material.Button variant="contained" sx={{ textTransform: "none" }} color='error' startIcon={<material.CloseIcon />} onClick={handleClose}>Close</material.Button>
                    </span>
                </material.DialogTitle>
                <material.DialogContent>
                    <material.TableContainer sx={{ maxHeight: 460, width: "100%" }}>
                        <material.Table stickyHeader aria-label="sticky table">
                            <material.TableHead >
                                <material.TableRow>
                                    <StyledTableCell>Treatment Name</StyledTableCell>
                                    <StyledTableCell>Action</StyledTableCell>
                                </material.TableRow>
                            </material.TableHead>
                            <material.TableBody>
                                {isLoading ? (
                                    <material.TableRow >
                                        <material.TableCell colSpan={4}>
                                            <SkeletonTheme baseColor="#bbdefb" highlightColor="#c6ff00" enableAnimation="true" inline="true" width="100% " height="30px">
                                                <Skeleton count={4} />
                                            </SkeletonTheme>
                                        </material.TableCell>
                                    </material.TableRow>
                                ) : (
                                    <>
                                        {treatmentList?.length ? treatmentList.map((row, i) => (
                                            <material.TableRow
                                                key={i}
                                                sx={{
                                                    '&:last-child td, &:last-child th': { border: 0 },
                                                }}
                                            >
                                                <material.TableCell sx={{ pt: 2, pb: 2 }} size='small'>{row.treatmentName}</material.TableCell>
                                                <material.TableCell size='small'>
                                                    <material.IconButton title='Edit Treatment' aria-label="create" size="large" onClick={() => editTreatment(row)}>
                                                        <material.CreateIcon color='primary' />
                                                    </material.IconButton>
                                                    <material.IconButton title="Delete Treatment" aria-label="create" size="large" onClick={() => deleteTreatment(row)}>
                                                        <material.DeleteIcon color='warning' />
                                                    </material.IconButton>
                                                </material.TableCell>
                                            </material.TableRow>
                                        )) : (
                                            <material.TableRow >
                                                <material.TableCell colSpan={4}>
                                                    <h6 className='d-flex justify-content-center text-danger fw-bold'>No data found</h6>
                                                </material.TableCell>
                                            </material.TableRow>
                                        )}
                                    </>)}
                            </material.TableBody>
                        </material.Table>
                        <hr />
                    </material.TableContainer>
                </material.DialogContent>
            </material.Dialog>
            <AddMasterTreatmentData
                openAddTreatmentDialog={openAddTreatmentDialog}
                setOpenAddTreatmentDialog={setOpenAddTreatmentDialog}
                clinicDetails={clinicDetails}
                userDetails={userDetails}
                getMasterTreatmentList={getMasterTreatmentList}
            />
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
        </div>
    );
}

export default ViewMasterTreatmentList;